import * as U from '@untitledui/icons';

export const Communication = {
  MessageChatSquare: U.MessageChatSquare,
  MessageDotsSquare: U.MessageDotsSquare,
  MessageTextSquare02: U.MessageTextSquare02,
  MessageCheckSquare: U.MessageCheckSquare,
  MessageCircle01: U.MessageCircle01,
  MessageSquare02: U.MessageSquare02,
  Send01: U.Send01,
};

export const Finance = {
  BankNote03: U.BankNote03,
};

export { default as HelpCircleFilled } from './HelpCircleFilled';
export { default as NotesStack } from './NotesStack';

export const General = {
  Bell04: U.Bell04,
  Eye: U.Eye,
  EyeOff: U.EyeOff,
  Plus: U.Plus,
  PlusCircle: U.PlusCircle,
  HelpCircle: U.HelpCircle,
  HelpSquare: U.HelpSquare,
  InfoCircle: U.InfoCircle,
  Link03: U.Link03,
  LinkBroken01: U.LinkBroken01,
  Settings01: U.Settings01,
  Settings04: U.Settings04,
  Check: U.Check,
  CheckCircle: U.CheckCircle,
  CheckCircleBroken: U.CheckCircleBroken,
  Circle: U.Circle,
  Mail01: U.Mail01,
  XClose: U.XClose,
  XCircle: U.XCircle,
  Loading02: U.Loading02,
  Copy01: U.Copy01,
  Copy03: U.Copy03,
  Copy06: U.Copy06,
  Trash01: U.Trash01,
  DotsVertical: U.DotsVertical,
  DotsHorizontal: U.DotsHorizontal,
  DotsGrid: U.DotsGrid,
  Translate01: U.Translate01,
  Download01: U.Download01,
  Edit04: U.Edit04,
  Edit05: U.Edit05,
  Share01: U.Share01,
  Share03: U.Share03,
  Pin01: U.Pin01,
  Pin02: U.Pin02,
  Zap: U.Zap,
  SearchSm: U.SearchSm,
  MarkerPin01: U.MarkerPin01,
  Tag01: U.Tag01,
  Building02: U.Building02,
  Clock: U.Clock,
  ClockRewind: U.ClockRewind,
  ClipboardPlus: U.ClipboardPlus,
  ClipboardCheck: U.ClipboardCheck,
  ActivityHeart: U.ActivityHeart,
  Briefcase01: U.Briefcase01,
  ShieldTick: U.ShieldTick,
  Truck01: U.Truck01,
  Package: U.Package,
  Tool01: U.Tool01,
  Scales02: U.Scales02,
  Award03: U.Award03,
  BookOpen01: U.BookOpen01,
  FilterLines: U.FilterLines,
  Rows01: U.Rows01,
  ThumbsUp: U.ThumbsUp,
  ThumbsDown: U.ThumbsDown,
};

export const Layout = {
  LayoutLeft: U.LayoutLeft,
};

export const Charts = {
  BarChartSquare01: U.BarChartSquare01,
};

export const MediaDevices = {
  Microphone01: U.Microphone01,
  LightBulb05: U.Lightbulb05,
  Camera01: U.Camera01,
  Image03: U.Image03,
  ImagePlus: U.ImagePlus,
  VideoRecorder: U.VideoRecorder,
  Play: U.Play,
};

export const Education = {
  GraduationHat01: U.GraduationHat01,
};

export const Editor = {
  Pencil01: U.Pencil01,
  PencilLine: U.PencilLine,
  Keyboard01: U.Keyboard01,
};

export const Arrow = {
  ChevronLeft: U.ChevronLeft,
  ChevronRight: U.ChevronRight,
  ChevronDown: U.ChevronDown,
  ChevronUp: U.ChevronUp,
  ChevronSelectorVertical: U.ChevronSelectorVertical,
  ArrowLeft: U.ArrowLeft,
  ArrowRight: U.ArrowRight,
  ArrowUp: U.ArrowUp,
  ArrowDown: U.ArrowDown,
  ArrowUpRight: U.ArrowUpRight,
  ArrowCircleBrokenLeft: U.ArrowCircleBrokenLeft,
  RefreshCcw01: U.RefreshCcw01,
  CornerDownRight: U.CornerDownRight,
  Expand01: U.Expand01,
};

export const Users = {
  UserCircle: U.UserCircle,
  User01: U.User01,
  User02: U.User02,
  UserEdit: U.UserEdit,
  Users01: U.Users01,
  Users03: U.Users03,
};

export const Time = {
  Calendar: U.Calendar,
  CalenderDate: U.CalendarDate,
  ClockCheck: U.ClockCheck,
};

export const Files = {
  FileX02: U.FileX02,
  File01: U.File01,
  File02: U.File02,
  File05: U.File05,
  FilePlus02: U.FilePlus02,
  FileQuestion02: U.FileQuestion02,
  FileAttachment02: U.FileAttachment02,
};

export const Shapes = {
  Circle: U.Circle,
  Square: U.Square,
  Star01: U.Star01,
  Star06: U.Star06,
  Star07: U.Star07,
};

export const Alerts = {
  AlertCircle: U.AlertCircle,
  AlertTriangle: U.AlertTriangle,
};

export const Medical = {
  MedicalCross: U.MedicalCross,
};

export const Weather = {
  Sun: U.Sun,
  CloudSun02: U.CloudSun02,
  SunSetting01: U.SunSetting01,
  Moon01: U.Moon01,
};

export const Security = {
  Lock01: U.Lock01,
  Lock03: U.Lock03,
};

export { U }; // optional: access flat icons if ever needed
